<template>
    <div class="fliter-list">
        <!-- 标题 -->
        <p class="list-title">
            {{listTitle}}
        </p>
        <!-- 列表 -->
        <ul class="list-box">
            <!-- 全部 -->
            <li>
                <a href="javascript:;"
                    @click="handleClick('')">
                    全部
                </a>
            </li>
            <!-- 20个以内 -->
            <template v-for="(item, index) in listData">
                <li v-if="index < 20"
                    :key="index">
                    <a href="javascript:;"
                        @click="handleClick(item.id || item.brand_id)">
                        {{item.cat_name || item.brand_name}}
                    </a>
                </li>
            </template>
            <!-- 20个以上 -->
            <template v-for="(item, index) in listData">
                <li v-if="index >= 20 && more"
                    :key="index">
                    <a href="javascript:;"
                        @click="handleClick(item.id || item.brand_id)">
                        {{item.cat_name || item.brand_name}}
                    </a>
                </li>
            </template>
            <!-- 查看更多 -->
            <li>
                <a href="javascript:;"
                    v-if="listData.length >= 20"
                    @click="handleMore">
                    {{more? '收起': '查看更多'}}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                more: false
            }
        },
        props: {
            listTitle: String,
            listData: {
                type: Array,
                default: []
            }
        },
        methods: {
            handleClick(value) {
                this.$emit('handleClick', value);
            },
            handleMore() {
                this.more = !this.more
            }
        },
    }
</script>

<style scoped>
.fliter-list {
    display: flex;
}
.list-title {
    flex-shrink: 0;
    width: 84px;
    padding: 4px 0;
    font-size: 16px;
    color: #b0b0b0;
}
.list-box {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
}
.list-box > li {
    margin-left: 26px;
}
.list-box > li > a {
    display: block;
    padding: 4px 0;
    color: #FF6700;
}
</style>